<ngx-spinner bdColor="rgb(63,69,95)" size="medium" color="#FFD700" [fullScreen]="true"
  template="<img src='../../../../../assets/images/salonza/loader.gif'/>">
  <p style="color: white"> </p>
</ngx-spinner>